(function (root, factory) {
  var api = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.HUDEFStockStatus = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function isAvailable(variant) {
    return Boolean(
      variant && (variant.available === true || variant.available === 'true')
    );
  }

  function forEachMatch(rootElement, selector, callback) {
    if (!rootElement) return;

    if (typeof rootElement.matches === 'function' && rootElement.matches(selector)) {
      callback(rootElement);
    }

    if (typeof rootElement.querySelectorAll !== 'function') return;

    Array.prototype.forEach.call(rootElement.querySelectorAll(selector), callback);
  }

  function sync(rootElement, variant, availabilityOverride) {
    var available =
      typeof availabilityOverride === 'boolean'
        ? availabilityOverride
        : isAvailable(variant);
    var variantId = variant && variant.id != null ? String(variant.id) : '';

    forEachMatch(rootElement, '[data-hudef-stock-state]', function (state) {
      state.classList.toggle('m:hidden', available);
      state.hidden = available;
      state.setAttribute('aria-hidden', available ? 'true' : 'false');
      state.setAttribute('data-hudef-variant-available', available ? 'true' : 'false');

      if (variantId) {
        state.setAttribute('data-variant-id', variantId);
      } else {
        state.removeAttribute('data-variant-id');
      }

      forEachMatch(state, '[data-hudef-notify-trigger]', function (trigger) {
        if (variantId) {
          trigger.setAttribute('data-variant-id', variantId);
        } else {
          trigger.removeAttribute('data-variant-id');
        }
      });
    });

    forEachMatch(rootElement, '[data-hudef-product-form]', function (form) {
      form.classList.toggle('hudef-product-form--out-of-stock', !available);
      form.setAttribute('data-hudef-variant-available', available ? 'true' : 'false');
    });

    return {
      available: available,
      variantId: variantId,
    };
  }

  function init(documentElement) {
    if (!documentElement || documentElement.__hudefStockStatusInitialized) {
      return;
    }

    documentElement.__hudefStockStatusInitialized = true;
    documentElement.addEventListener('variant:changed', function (event) {
      var detail = event.detail || {};
      var productInfo = detail.productInfo;

      if (productInfo) {
        sync(productInfo, detail.variant, detail.available);
      }
    });

    Array.prototype.forEach.call(documentElement.querySelectorAll('product-info'), function (productInfo) {
      var state = productInfo.querySelector('[data-hudef-stock-state]');
      var available = state && state.getAttribute('data-hudef-variant-available');
      var variant = productInfo.querySelector('[data-selected-variant]');
      var parsedVariant = null;

      if (variant) {
        try {
          parsedVariant = JSON.parse(variant.textContent);
        } catch (error) {
          parsedVariant = null;
        }
      }

      if (available !== null) {
        sync(productInfo, parsedVariant, available === 'true');
      }
    });
  }

  return {
    init: init,
    isAvailable: isAvailable,
    sync: sync,
  };
});

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  var initializeHudefStockStatus = function () {
    if (window.HUDEFStockStatus) {
      window.HUDEFStockStatus.init(document);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeHudefStockStatus, { once: true });
  } else {
    initializeHudefStockStatus();
  }
}
